import React from "react";
import { Seo } from "../lib/seo";
import { Section, SectionHead, Button, Badge, StatusDot, Callout } from "../components/ui";
import { ConversationTranscript, DataTable, FaqAccordion } from "../components/marketing";

export default function Styleguide() {
  return (
    <>
      <Seo title="Styleguide" path="/styleguide" noindex description="Design system" />
      <Section>
        <SectionHead label="Styleguide" title="BloomCONNECT design system." intro="Tokens, primitives and marketing blocks in one place." />
        <div className="mt-8 space-y-12">
          <div><div className="eyebrow mb-3">Colour</div><div className="flex flex-wrap gap-2">{["bg-ink-950","bg-ink-600","bg-brand-700","bg-brand-600","bg-brand-500","bg-brand-050","bg-surface-sunk","bg-signal"].map(c=><div key={c} className={`h-12 w-24 rounded ${c} border border-line`} />)}</div></div>
          <div><div className="eyebrow mb-3">Buttons</div><div className="flex flex-wrap gap-3"><Button variant="primary" size="lg">Primary</Button><Button variant="secondary" size="md">Secondary</Button><Button variant="ghost" size="sm">Ghost</Button></div></div>
          <div><div className="eyebrow mb-3">Badges & status</div><div className="flex items-center gap-4"><Badge>New</Badge><StatusDot /></div></div>
          <div><div className="eyebrow mb-3">Table</div><DataTable head={["Model","Reliability","Cost"]} rows={[["BloomCONNECT","Top-tier","0.25 flat"],["GPT-5","Very high","8–20×"]]} /></div>
          <div><div className="eyebrow mb-3">Transcript</div><ConversationTranscript channel="WhatsApp" messages={[{from:"them",text:"how much?",time:"09:00"},{from:"agent",text:"₱1,800 delivered. Book you in?",time:"09:00"}]} /></div>
          <div><div className="eyebrow mb-3">Callout</div><Callout tone="warning" title="Fair notice">It's good at its job.</Callout></div>
          <div><div className="eyebrow mb-3">FAQ</div><FaqAccordion items={[{question:"Is this a chatbot?",answer:"No, it's a sales agent."}]} /></div>
        </div>
      </Section>
    </>
  );
}
